import React from 'react';

import { CONTENT_BY_MODEL_NAME } from './Content/Content';
import ContentAlt from './ContentAlt/ContentAlt';
import InfoBubble from './InfoBubble';
import InfoBubbleAlt from './InfoBubbleAlt';

export const ANNOTATIONS_BY_TYPE = {
  1: InfoBubble,
};

const RenderImageAnnotation = (props) => {
  const {
    annotationModel,
    annotationModelId,
    annotationTypeId,
    assetId,
    altInfoBubble
  } = props;

  const ContentComponent = altInfoBubble ? ContentAlt : CONTENT_BY_MODEL_NAME[annotationModel];
  const AnnotationComponent = altInfoBubble ? InfoBubbleAlt : ANNOTATIONS_BY_TYPE[annotationTypeId];

  return (
    <AnnotationComponent { ...props }>
      <ContentComponent
        { ...props }
        annotationModelId={ annotationModelId }
        assetId={ assetId }
      />
    </AnnotationComponent>
  );
};

// This function "should" work on any board { ..., image } or
// vendorVariant { ..., image } returned from graph
export const ImageAnnotations = ({ assetId, annotations, altInfoBubble }) => {
  return annotations.map((annotation) => (
    <RenderImageAnnotation
      assetId={ assetId }
      key={ annotation.id }
      altInfoBubble={altInfoBubble}
      { ...annotation }
    />
  ));
};
